import PropTypes from 'prop-types'
import { APP_STEP } from './../../actions/app'
import { ACCESS_PENDING, accessConfirmationCancelled } from '../../actions/webrtcConnection'
import { setDisconnectMessage, gracefulExit } from '../../actions/disconnect'
import { CLOSE_TIMEOUT } from '../../lib/WebRTC'

// store state props that are needed to decide if
// the modal should be displayed or not
// (however shouldDisplay will receive the whole store state)
// AppModal use this props to react only to this prop changes,
// not to every store state change
const stateProps = {
  'app.step': PropTypes.number.isRequired,
  'app.message': PropTypes.string.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  app: {
    step,
    message,
  },
}) => {
  return (
    step < APP_STEP.RUNNING &&
    message
  )
}
/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({
  state: {
    app: {
      step,
      message,
    },
    webrtcConnection: {
      unstable: connectionUnstable,
      accessState,
    },
  },
  dispatch,
  translate,
}) => {
  let iconClass = 'modal-icon-connecting'
  let title = step >= APP_STEP.RTC_WAIT_CONFIRM_ACCESS ? 'title-connected' : 'title-connecting'
  if (step >= APP_STEP.RTC_WAIT_CONFIRM_ACCESS) {
    title = connectionUnstable ? 'title-connected-unstable' : 'title-connected'
    iconClass = connectionUnstable
      ? 'modal-icon-ondemand-connection-unstable'
      : 'modal-icon-ondemand-wait-access'
  }

  const onCancel = () => {
    dispatch(accessConfirmationCancelled())
    dispatch(setDisconnectMessage('disconnect-by-you'))
    dispatch(gracefulExit())
  }

  const buttons = (accessState === ACCESS_PENDING) // step >= APP_STEP.RTC_WAIT_CONFIRM_ACCESS
    ? [{ text: 'btn-cancel', onClick: onCancel }]
    : null

  const note = connectionUnstable
    ? translate('connection-unstable-note', { seconds: CLOSE_TIMEOUT })
    : null

  // return modal data
  return {
    iconClass,
    title,
    body: message,
    note,
    buttons,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
